var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('full-calendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}}),_c('div',{staticClass:"d-block d-sm-none"}),_c('div',{staticClass:"d-none d-sm-block",attrs:{"id":"desktopCalendarView"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }